import type { Client } from "../services/UserService";

const REVAHUB_WORDMARK = "/logos/revahub-wordmark.svg";
const REVAHUB_MARK = "/logos/revahub-mark.svg";

type BrandingContext = "global" | "tenant";

export interface HeaderBranding {
  context: BrandingContext;
  logoSrc: string;
  logoAlt: string;
  tenantName?: string;
  poweredByMarkSrc: string;
  showTenantBadge: boolean;
}

const pickFirst = (...values: Array<string | undefined | null>) =>
  values.find((value) => typeof value === "string" && value.trim().length > 0)?.trim();

export const resolveHeaderBranding = (selectedClient: Client | null): HeaderBranding => {
  if (!selectedClient) {
    return {
      context: "global",
      logoSrc: REVAHUB_WORDMARK,
      logoAlt: "Revahub",
      poweredByMarkSrc: REVAHUB_MARK,
      showTenantBadge: false,
    };
  }

  const tenantWordmark = pickFirst(
    selectedClient.logo_wordmark_url,
    selectedClient.clientLogoWordmarkUrl,
    selectedClient.logo_url,
    selectedClient.clientLogoUrl
  );

  return {
    context: "tenant",
    logoSrc: tenantWordmark || REVAHUB_WORDMARK,
    logoAlt: tenantWordmark ? `Logo ${selectedClient.clientName}` : "Revahub",
    tenantName: selectedClient.clientName,
    poweredByMarkSrc: REVAHUB_MARK,
    showTenantBadge: !tenantWordmark,
  };
};
